import { useState } from 'react'
import Button from '@mui/material/Button'
import Icon from '@mui/material/Icon'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'

import FormErrorAlert from './reusables/error-alert'
import YearlyFeeDiscountFilter from '../filters/yearly-fee-discount-filter'
import { useYearlyFeePayerAssignDiscount } from '@/hooks/api/use-yearly-fee-payers'

export default function AssignDiscountToPayerCustomForm({
    feePayerId,
    closeCallback,
}: {
    feePayerId: number,
    closeCallback?: () => void,
}) {

    const [discountId, setDiscountId] = useState<number | null>(null)
    const [requestInProgress, setRequestInProgress] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)


    const mutation = useYearlyFeePayerAssignDiscount(
        feePayerId,
        {
            onSuccessCallback: closeCallback,
            setRequestInProgress,
            onErrorCallback(errorMessage) {
                setError(errorMessage)
            },
        },
    )

    const handleSubmit = () => {
        setRequestInProgress(true)
        mutation.mutate(discountId)
    }

    return (
        <Box sx={(theme) => ({
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            backgroundColor: theme.palette.customLightYellow.light,
            borderRadius: 2,
            border: '1px solid '+theme.palette.customLightYellow.main,
            padding: theme.spacing(1.5, 2),
            position: 'relative',
        })}>
            <Box>
                <Typography variant="h5" component="h3" >
                    Přidat poplatníkovi slevu
                </Typography>
                {closeCallback &&
                    <Box sx={{
                        position: 'absolute',
                        top: 4,
                        right: 4,
                    }}>
                        <IconButton
                            aria-label="close"
                            size="small"
                            color="secondary"
                            onClick={() => closeCallback()}
                        >
                            <Icon>close</Icon>
                        </IconButton>
                    </Box>
                }
                {error &&
                    <FormErrorAlert error={error} setError={setError} />
                }
            </Box>
            <Box sx={{
                py: 2,
                display: 'flex',
                flexWrap: 'wrap',
                gap: 2,
                justifyContent: 'center',
            }}>
                <YearlyFeeDiscountFilter
                    selectedId={discountId}
                    setSelectedId={setDiscountId}
                    label="Sleva"
                    hideCustom
                />
            </Box>
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                flexGrow: 1,
            }}>
                <Button
                    variant="text"
                    color="terciary"
                    onClick={() => closeCallback()}
                >
                    Zrušit
                </Button>
                <Button
                    variant="contained"
                    color="success"
                    startIcon={requestInProgress ? <CircularProgress color="inherit" size={20} /> : <CheckCircleRoundedIcon />}
                    onClick={() => handleSubmit()}
                    disabled={requestInProgress || !discountId}
                >
                    Přidat
                </Button>
            </Box>
        </Box>
    )
}
